// extracted by mini-css-extract-plugin
module.exports = {"root":"Header_root__2p8KE","title":"Header_title__RdpHV","left":"Header_left__1LC4j","clinicName":"Header_clinicName__3Nl9k"};